export default {
  common: {
    answer: 'Trả lời',
    send: 'Gửi',
    selectNumberOfPointsToSend: 'Chọn số điểm để gửi',
    informationForExtensionFile: 'Thông tin phần mở rộng của tệp đính kèm',
    viewVideo: 'Xem video',
    file: 'Tệp',
    close: 'Đóng',
    sendPoint: 'Gửi Điểm',
    download: 'Tải về',
    downloadFile: 'Tải file: {filename}',
    comment: 'Bình luận',
    coin: 'Xu',
    point: 'Điểm',
    countSuffix: '',
    login: 'Đăng nhập',
    unsolved: 'Chưa giải quyết',
    resolved: 'Đã giải quyết',
    male: 'Nam',
    female: 'Nữ',
    all: 'Tất cả',
    notAllowedFileType: 'Tệp này không phù hợp',
    congratulation: 'Xin chúc mừng!',
    receivedPointFromCompany: 'Bạn nhận được {n} điểm từ công ty',
    receivedCreditFromCompany: 'Bạn nhận được {n} credit từ công ty',
    note: 'Lưu ý',
    message: 'Tin nhắn',
    warning_maintenance_title: 'Bảo trì hệ thống',
    warning_maintenance1:
      'Vì chúng tôi hiện đang tiến hành bảo trì hệ thống nên không thể sử dụng Cheeers.',
    warning_maintenance2:
      'Chúng tôi xin lỗi vì sự bất tiện này, mong nhận được sự thông cảm của bạn.',
    warning_maintenance_footer: 'Để biết thêm thông tin, xin vui lòng liên hệ với chúng tôi.',
    system_notify: 'Thông báo từ hệ thống',
  },
  time: {
    day: 'Ngày',
    minute: 'phút',
    second: 'giây',
    hours: '0 giờ | 1 giờ | {count} giờ',
    days: '0 ngày | 1 ngày | {count} ngày',
    months: '0 tháng | 1 tháng | {count} tháng',
    weeks: '0 tuần | 1 tuần | {count} tuần',
    years: '0 năm | 1 năm | {count} năm',
    nHours: '0 giờ | 1 giờ | {count} giờ',
    nMinutes: '0 phút | 1 phút | {count} phút',
    nSeconds: '0 giây | 1 giây | {count} giây',
    inToday: 'Trong hôm nay',
    untilTomorrow: 'Hết ngày mai',
    inDays: 'trong 0 ngày | trong 1 ngày | trong {count} ngày',
    inWeeks: 'trong 0 tuần | trong 1 tuần | trong {count} tuần',
    inMonths: 'trong 0 tháng | trong 1 tháng | trong {count} tháng',
  },
  calendar: {
    formatMonthDay: 'Do (ddd)',
  },
  lang: {
    ja: '日本語',
    en: 'English',
    vi: 'Tiếng Việt',
  },
  menu: {
    home: 'Trang chủ',
    issue: 'Câu hỏi',
    message: 'Lời cảm ơn',
    exchange: 'Đổi quà',
    eLearning: 'Học',
    bulletinBoard: 'Thông báo',
    profile: 'Hồ sơ',
  },
  issue: {
    myQuestionBox: 'Lịch sử câu hỏi',
    supporting: 'Đang hỗ trợ',
    unResolved: 'Chưa giải quyết',
    solved: 'Đã giải quyết',
    resolveBySelf: 'Tự mình giải quyết',
    all: 'Tất cả',
    changeToResolved: 'Chuyển trạng thái sang đã giải quyết',
    whoHelpToResolve: 'Người hỗ trợ giải quyết vấn đề',
    shareHowToSolveProblem: 'Hãy chia sẽ giải pháp của bạn với mọi người!',
    noOneHelpToResolve: 'Tự giải quyết',
    resolve: 'Đăng nội dung',
    choose: 'Chọn',
    choosePoint: 'Chọn điểm tặng cho người hỗ trợ',
    selected: 'Đã chọn',
    addReaction: 'Thể hiện cảm xúc',
    body: {
      solved: 'Đã giải quyết',
    },
    download: '[{filename}]: Tải về',
  },
  validation: {
    wrongCredential: 'Email hoặc mật khẩu không chính xác',
    alpha: '{_field_} chỉ có thể chứa các kí tự chữ',
    alpha_dash:
      '{_field_} có thể chứa các kí tự chữ (A-Z a-z), số (0-9), gạch ngang (-) và gạch dưới (_)',
    alpha_num: '{_field_} chỉ có thể chứa các kí tự chữ và số',
    alpha_spaces: '{_field_} chỉ có thế chứa các kí tự và khoảng trắng',
    between: '{_field_} phải có giá trị nằm trong khoảng giữa {min} và {max}',
    confirmed: '{_field_} khác với {target}',
    digits: 'Trường {_field_} chỉ có thể chứa các kí tự số và bắt buộc phải có độ dài là {length}',
    dimensions: '{_field_} phải có chiều rộng {width} pixels và chiều cao {height} pixels',
    email: '{_field_} phải là một địa chỉ email hợp lệ',
    excluded: '{_field_} không phải là một giá trị hợp lệ',
    ext: '{_field_} phải là một tệp',
    image: 'Trường {_field_} phải là một ảnh',
    oneOf: '{_field_} không phải là một giá trị hợp lệ',
    max: '{_field_} không thể có nhiều hơn {length} kí tự',
    max_value: '{_field_} phải nhỏ hơn hoặc bằng {max}',
    mimes: '{_field_} phải chứa kiểu tệp phù hợp',
    min: '{_field_} phải chứa ít nhất {length} kí tự',
    min_value: '{_field_} phải lớn hơn hoặc bằng {min}',
    numeric: '{_field_} chỉ có thể có các kí tự số',
    regex: '{_field_} có định dạng không đúng',
    required: '{_field_} là bắt buộc',
    required_if: '{_field_} là bắt buộc',
    size: '{_field_} chỉ có thể chứa tệp nhỏ hơn {size}KB',
    double: '{_field_} phải là một số thập phân hợp lệ',
    strong_password: '{_field_} Phải chứa số, chữ viết hoa và chữ viết thường',
    max_size_file: 'Kích thước tệp tin phải nhỏ hơn {max_size}MB',
  },
  description: {
    pointTimer: 'Điểm của bạn sẽ được reset trong {0}',
  },
  navbar: {
    attendanceManagement: 'Quản lý chấm công',
    working: {
      start: 'Bắt đầu làm việc',
      startBreak: 'Nghĩ giữa giờ',
      finishBreak: 'Tiếp tục làm việc',
      stop: 'Kết thúc làm việc',
      dailyReport: 'Báo cáo mỗi ngày',
    },
    setting: 'Cài đặt chung',
    logout: 'Đăng xuất',
    workingTime: 'Thời gian làm việc',
    attendanceTable: 'Chấm công',
  },
  sidebar: {
    cheeersCoin: 'Cheeers coin',
    exchangeForGoods: 'Đổi sản phẩm',
    remainPoint: 'Còn lại',
    expireTime: 'Thời gian hết hạn',
    coinRaking: 'Điểm xếp hạng',
    sendGift: 'Tặng quà ',
    receivedThanksRanking: 'Bảng xếp hạng lời cảm ơn đã nhận được',
    byMonth: 'của tháng',
  },
  login: {
    noteSarafi: '※ Vui lòng bật Cookie trong cài đặt',
    email: 'Email',
    password: 'Mật khẩu',
    forgotPassword: 'Quên mật khẩu',
    rememberUsername: 'Ghi nhớ thông tin tài khoản',
    language: 'Ngôn ngữ',
  },
  home: {
    listQuestion: 'Câu hỏi của mọi người',
    all: 'Tất cả',
    unsolved: 'Chưa giải quyết',
    resolved: 'Đã giải quyết',
    cooperated: 'Hợp tác',
    sort: 'Sắp xếp',
    btnPostQuestion: 'Đăng câu hỏi',
    issueItem: {
      header: {
        postIssueCreated: 'Thời gian đăng ',
        btnUnresolved: 'Chưa được giải quyết',
        btnResolved: 'Đã giải quyết',
        supporting: 'Đang giúp đỡ',
        coinEarn: 'Coin bạn có thể kiếm ',
        endRecruitment: 'Cho đến khi kết thúc cuộc tuyển dụng',
      },
      contentRight: {
        btnTalk: 'Cuộc trò chuyện',
        btnApplied: 'Đã áp dụng',
        now: 'Bây giờ có',
        peopleAppling: 'đang nộp đơn',
        earnCoin: 'kiếm ',
      },
      contentLeft: {
        btnResolved: 'Đã giải quyết ！',
      },
      comments: {
        talkTo: 'Trò chuyện với {name}',
      },
    },
    dialogPostQuestion: {
      post: 'Đăng câu hỏi',
      type: 'Chọn loại câu hỏi',
      title: 'Nhập tiêu đề cho câu hỏi',
      content: 'Nội dung câu hỏi',
      expiredTime: 'Muốn giải quyết trong bao lâu ？',
      timeLine: 'Thời gian',
      submit: 'Đăng câu hỏi',
    },
  },
  profile: {
    title: 'Thông tin người dùng',
    avatarTitle: 'Ảnh đại diện',
    informationTitle: 'Thông tin cá nhân',
    maxFileSizeWarning: 'Hình ảnh lớn nhất: {size}',
    button: {
      uploadAvatar: 'Thay đổi hình ảnh',
      submit: 'Lưu thông tin',
    },
    field: {
      avatar: 'Hình sẽ tự động được cắt theo hình tròn',
      name: 'Họ tên',
      email: 'Địa chỉ email',
      birthday: 'Ngày sinh',
      gender: 'Giới tính',
      status: 'Bình luận',
    },
    cumulative: 'Tích lũy',
    coinsReceived: 'Số xu nhận được',
    numTimesReceived: 'Số lần nhận được',
    yearOfService: 'Số năm làm việc',
  },
  setting: {
    title: 'Cài đặt',
    languageSetting: 'Ngôn ngữ',
    notificationSetting: 'Thông báo',
    receivePostNotification: 'Thông báo bài viết mới',
    receiveThanksNotification: 'Thông báo cảm ơn',
    receiveTalkNotification: 'Thông báo nói chuyện',
    pointSetting: 'Điểm',
    pointSettingNote1: 'Bạn có thể cái đặt 5 loại điểm khác nhau',
    pointSettingNote2: 'Bạn có thể thay đổi nó bất cứ khi nào',
    passwordSetting: 'Mật khẩu',
    newPassword: 'Mật khẩu mới',
    newPasswordConfirm: 'Xác nhận mật khẩu mới',
    updated: 'Cập nhật thành công',
  },
  thanks: {
    title: 'Lời cảm ơn',
    addThanks: 'Gửi lời cảm ơn',
    earnCoin: 'Nhận ',
    showMore: 'Xem nhiều hơn',
    showLess: 'Xem ít hơn',
    filter: {
      all: 'Tất cả các tin nhắn',
      forYou: 'Đến bạn',
      fromMe: 'Từ bạn',
    },
  },
  addThanks: {
    title: 'Gửi lời cảm ơn',
    filter: {
      branch: 'Chi nhánh',
      group: 'Nhóm',
      search: 'Tìm kiếm theo tên',
    },
    button: {
      thank: 'Gửi lời cảm ơn',
      submit: 'Gửi lời cảm ơn',
    },
    selectPoint: 'Chọn số điểm gửi',
    message: 'Gửi thông điệp cảm ơn',
    category: 'Chọn thông điệp',
    sendAThankMessageTo: 'Gửi lời cảm ơn đến {name}',
  },
  exchange: {
    title: 'Benefit',
    sidebar: {
      title: 'Đổi xu',
    },
    content: {
      title: 'Danh sách sản phẩm',
      viewDetail: 'Xem chi tiết',
    },
    itemDetail: {
      title: 'Chi tiết sản phẩm',
      exchangeForProduct: 'Đổi quà',
      dontHaveProductInStock: 'không còn sản phẩm trong kho',
      dontHaveEnoughCoin: 'Bạn không đủ điểm để trao đổi',
    },
    history: {
      title: 'Lịch sử đổi quà',
    },
    purchaseCompleted: {
      title: 'Đổi quà thành công',
      thanks: 'Cám ơn bạn đã đổi quà!',
      receivingMethodBelow: 'Vui lòng kiểm tra phương thức nhận hàng bên dưới',
      methodReceive: 'Cách thức nhận quà',
      doneStock: 'Hiện tại đang có sẵn trên văn phòng, bạn có thể đến lấy.',
      close: 'Đóng',
      instructionReceiveProduct: 'Hướng dẫn cách nhận sản phẩm :',
    },
  },
  systemNotification: {
    receivedPoint: {
      title: 'Xin chúc mừng ！',
      given: 'đã gửi',
      forYou: 'cho bạn ！',
      exchange: 'Xác nhận bình luận',
    },
    popUp: {
      confirm: 'Bạn có muốn rời khỏi trang này không? Những bình luận bạn đã nhập sẽ không được lưu.',
    }
  },
  working: {
    actions: {
      checkin: {
        success: 'Điểm danh thành công, chúc bạn một ngày làm việc vui vẻ!',
        fail: 'Điểm danh không thành công, vui lòng liên hệ với quản lí của bạn!',
        title: 'Bạn muốn bắt đầu thời gian làm việc?',
      },
      checkout: {
        success: 'Kết thúc thành công',
        fail: 'Kết thúc không thành công, vui lòng liên hệ với quản lí của bạn!',
        title: 'Bạn muốn kết thúc thời gian làm việc?',
      },
      pause: {
        success: 'Tạm dừng thành công',
        fail: 'Tạm dừng không thành công, vui lòng liên hệ với quản lí của bạn!',
        title: 'Bạn muốn nghĩ giải lao?',
      },
      continue: {
        success: 'Quay lại làm việc thành công',
        fail: 'Quay lại làm việc không thành công, vui lòng liên hệ với quản lí của bạn!',
        title: 'Bạn muốn tiếp tục thời gian làm việc?',
      },
    },
  },
  eLearning: {
    date: 'Ngày',
    sendSuccess: 'gửi thành công',
    allCategory: '@:common.all',
    learningProgress: 'Tiến độ học',
    correctAnswer: 'Số câu đúng',
    answerProgress: 'Tiến độ trả lời',
    numberOfCorrectAnswer: 'Số câu đúng',
    notAttended: 'Không có câu hỏi',
    question: 'Câu hỏi',
    nQuestions: '0 câu | 1 câu | {n} câu',
    learn: 'Xem tài liệu',
    viewTestResult: 'Xem kết quả test',
    doTheTest: 'Làm test',
    startTheTest: 'Bắt đầu test',
    pageNumber: 'Tổng số trang',
    nPages: '0 trang | 1 trang | {n} trang',
    limitTime: 'Giới hạn thời gian',
    testResult: 'Kết quả test',
    questionNoN: 'Câu hỏi số {n}',
    numberOfQuestion: 'Số câu hỏi',
    testQuestionNote: '※ Mỗi câu hỏi sẽ có giới hạn thời gian để trả lời',
    remainTimeToAnswer: 'Thời gian còn lại',
    nextQuestion: 'Câu hỏi tiếp theo',
  },
  attendance: {
    title: 'Quản lý chấm công',
    checkAttendanceTable: 'Kiểm tra bảng chấm công',
    checkDailyAttendance: 'Kiểm tra chấm công hàng ngày',
    stamp: 'Chấm công',
    checkinTime: 'Vào làm',
    checkoutTime: 'Kết thúc',
    startBreak: 'Bắt đầu nghỉ',
    endBreak: 'Kết thúc nghỉ',
    workingHours: 'Số giờ công',
    overtimeHours: 'Tăng ca',
    dailyReport: 'Báo cáo hằng ngày',
  },
  bulletin: {
    create: {
      titleHeader: 'Đăng thông báo',
      title: 'Tiêu đề cho bản tin',
      contentTitle: 'Viết những gì bạn muốn chia sẻ với mọi người!',
      imageTitle: 'Thêm ảnh',
      attachFile: 'Thêm tập tin đính kèm',
      submit: 'Đăng bài',
      contentPlaceholder: 'Vui lòng nhập nội dung tại đây',
      chooseImage: 'Chọn hình ảnh',
      chooseAttachment: 'Chọn tệp đính kèm',
      txtFieldTitleName: 'Tiêu đề thông báo',
      txtFieldContentName: 'Nội dung thông báo',
    },
  },
  dailyReport: {
    title: 'Gửi báo cáo hôm nay',
    comment: 'Nhập nội dung báo cáo',
    attachment: 'Tệp đính kèm',
    chooseFileAttachment: 'Chọn tệp đính kèm',
    selectIcons: 'Tâm trạng của bạn',
    submit: 'Đăng báo cáo',
  },
  editComment: {
    title: 'Chỉnh sửa bình luận',
    submit: 'Cập nhật',
    delete: 'Xóa',
    message: 'Nội dung',
    txtFieldCommentName: 'Giải pháp',
  },
  surveyQuestion: {
    number: 'Câu hỏi {0}',
    dialog: {
      content1: 'Khảo sát Cheeers',
      content2: 'Vui lòng hợp tác với khảo sát tương tác nội bộ',
      start: 'Bắt đầu',
    },
  },
  mission: {
    notice: 'Công ty cần {times} lần nữa để hoàn thành nhiệm vụ này',
    letClearMission: 'Hãy cùng nhau hoàn thành nhiệm vụ nào !',
    deadline: 'Thời hạn',
    clear: 'Nhiệm vụ đã hoàn thành !',
    title: 'Nhiệm vụ',
    currentEarnedTrophy: 'Danh hiệu hiện tại đã giành được',
    finish: 'Hoàn thành nhiệm vụ!!',
    missionOfMonth: 'Nhiệm vụ của tháng này {2}/{1}/{0} ~ {5}/{4}/{3}',
    startMission: 'Bắt đầu nhiệm vụ! Hãy hăng hái lên nào!',
    fiftyPercent: 'Đã bức phá {times} lượt! Thời điểm bước ngoặt! ',
    clearMission: 'Nhiệm vụ hoàn thành ! Xin chúc mừng !',
    item: {
      content: 'Tất cả hãy cùng <span class="font-weight-bold">{content}</span> trong tháng này !',
    },
    popUp: {
      text1: 'Nhiệm vụ {number}',
      text2: 'Hoàn thành !!',
    },
    trophyVision: 'Vision',
    trophyRelationships: 'Relationships',
    trophyContribute: 'Contribute',
    trophyGrowth: 'Growth',
    trophyAttendance: 'Attendance',
  },
  sloganAnswer: {
    question: '{slogan} của công ty là ?',
    correctAnswer: 'Tuyệt vời! Câu trả lời chính xác!',
    errorMessage: 'Rất tiếc, câu trả lời đúng là "{correctAnswer}". Bạn có muốn thử lại không ?',
    yes: 'Có',
    cancel: 'Đóng',
  },
};
